import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async getMeasure({ commit }, measureId) {
      try {
        const response = await api.get(`/documents/measures/${measureId}`)

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async autoApproveMeasure({ commit }, measureId) {
      try {
        return await api.put(`/documents/measures/${measureId}/auto-approve`)
      } catch (error) {
        throw error
      }
    },

    async resendMeasureToApprovation({ commit }, measureId) {
      try {
        return await api.put(
          `/documents/measures/${measureId}/resend-to-approvation`,
        )
      } catch (error) {
        throw error
      }
    },

    async updateItemsMeasure({ commit }, data) {
      try {
        return await api.put(
          `/documents/measures/${data.measureId}/items`,
          data,
        )
      } catch (error) {
        throw error
      }
    },

    async addAttachMeasure({ commit }, data) {
      try {
        return await api.post(
          `/documents/measures/${data.get('measureId')}/attachs`,
          data,
        )
      } catch (error) {
        throw error
      }
    },

    async deleteAttachMeasure({ commit }, data) {
      try {
        return await api.delete(
          `/documents/measures/${data.measureId}/attachs/${data.id}`,
        )
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
